import { BASE_URL } from "./ServerEndpointController";
import axios from 'axios';

const NEWS_ENDPOINT = `${BASE_URL}/news`;
export async function getNewsData(page_name) {
    try {
        const response = await axios.get(`${NEWS_ENDPOINT}/${page_name}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching news data:', error);
    }
};

export async function updateNewsData(page_name, data) {
    try {
        const response = await axios.put(`${NEWS_ENDPOINT}/${page_name}`, data);
        return response.data;
    } catch (error) {
        console.error('Error updating news data:', error);
    }
}

export async function deleteNewsData(page_name, index) {
    try {
        const response = await axios.delete(`${NEWS_ENDPOINT}/${page_name}/${index}`);
        return response.data;
    } catch (error) {
        console.error('Error deleting news data:', error);
    }
}